import { privateApi } from "../utils/axios";

// Fetch all activities for a specific event
export const getEventActivities = async (eventId) => {
  const response = await privateApi.get(`/events/${eventId}/activities`, {
    params: { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }
  });
  return response.data;
};

// Fetch all activities for multiple events
export const getEventsActivities = async (eventIds) => {
  const response = await privateApi.get(`/events/multi-view/activities`, {
    params: { eventIds: eventIds.join(','), timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }
  });
  return response.data;
};

// Create a new activity for a specific event
export const createActivity = async (eventId, activityData) => {
  const response = await privateApi.post(`/events/${eventId}/activities`, activityData);
  return response.data;
};

// Fetch specific activity
export const getActivity = async (activityId) => {
  const response = await privateApi.get(`/activities/${activityId}`);
  return response.data;
};

// Update an activity
export const updateActivity = async (activityId, activityData) => {
  const response = await privateApi.put(`/activities/${activityId}`, activityData);
  return response.data;
};

// Delete an activity
export const deleteActivity = async (activityId) => {
  const response = await privateApi.delete(`/activities/${activityId}`);
  return response.data;
};
